import { sortBy } from 'lodash-es';
import { Service } from 'services/ApiService/ServiceBoard/ServiceBoardApiClient';

export enum SortField {
    Title = 'title',
    Category = 'category'
}

export const getSortField = (name: Nullable<string>): SortField => {
    if (!name) {
        return SortField.Title;
    }

    const fieldName = name.toLowerCase();
    if (Object.values(SortField as object).includes(fieldName)) {
        return fieldName as SortField;
    }
    return SortField.Title;
};

const sortServicesByTitle = (
    services: Service[],
): Service[] => sortBy(services, x => x.title?.toLocaleLowerCase());

const sortServicesByCategory = (
    services: Service[],
): Service[] =>
    sortBy(services, [x => x.category?.name, x => x.subcategory?.name, x => x.title?.toLocaleLowerCase()]);

const SORT_FUNCTIONS = {
    title: sortServicesByTitle,
    category: sortServicesByCategory,
};

export const sortServicesBy = (
    services: Service[],
    sortField: SortField,
): Service[] => {
    return SORT_FUNCTIONS[sortField](services);
};